import { DismissibleWarning as modelDismissibleWarning } from '@fullstory/client-api';
import { DismissibleWarning as protoDismissibleWarning } from '@fullstory/proto/fs/services/webber';

export const dismissibleWarningProtoToDismissibleWarningModel = (
  dismissedWarning?: protoDismissibleWarning,
): modelDismissibleWarning | undefined => {
  if (!dismissedWarning) {
    return undefined;
  }

  switch (dismissedWarning) {
    case protoDismissibleWarning.DISMISSIBLE_WARNING_METRIC_SAVE_DELETE_INSIGHT:
      return modelDismissibleWarning.WarningMetricSaveDeleteInsights;
    default:
      return modelDismissibleWarning.WarningUnknown;
  }
};
